import { getContext, setContext } from 'svelte'

import { ResultSync } from '$lib/utils/result'
import { setRollover } from '$lib/utils/array'

const CONTEXT = Symbol('BODY')

export function createLightroomContext(): LightroomContext {
      return setContext(CONTEXT, new LightroomContext())
}

export function getLightroomContext(): LightroomContext {
      return getContext(CONTEXT)
}

export class LightroomContext {
      visible = $state(false)
      content: any[] = $state([])
      selected: number = $state(0)
      selectedElement: any = $state(null)

	  closeResolve: Function|null = null
	  closePromise: Promise<boolean>|null = null

      constructor() {
            return this
      }

      open() {
            this.visible = true
            return this
      }

      close() {
            this.visible = false
			if( this.closeResolve ) this.closeResolve(true)
            return this
      }

      toggle() {
            this.visible = !this.visible
            return this
      }

      next() {
            this.selected = setRollover(this.selected, this.content.length, +1)
            this.switchElement()
            return this
      }

      previous() {
            this.selected = setRollover(this.selected, this.content.length, -1)
            this.switchElement()
            return this
      }

      setContent(content: any[], index = 0) {
            this.selected = index
            this.content = content
            this.switchElement()
            return this
      }

      switchElement() {
            this.selectedElement = this.content[this.selected]
            return this
      }

	  async waitForClose() {
		this.closePromise = new Promise( r => {
			this.closeResolve = r
		})

		this.closeCleanup()
		return this.closePromise
	}
	
	async closeCleanup() {
		await this.closePromise
		this.closeResolve = null
		this.closePromise = null
	  }
}
